// groued vector names
export const groupedVecs = {
  duplicate: ['r', 'g', 'b'],
  perception: ['oa', 'ol', 'ob'],
  distance: ['ref0', 'ref1', 'ref2']
}

export const getSearchFields = () => {
  return Reflect.ownKeys(groupedVecs).map(f=>groupedVecs[f]).flat(Infinity)
}
export const stripSettings = {
  indices: [{
    indexName: "fidstrips",

    "settings": {
      "number_of_shards": 1
    },

    "mappings": {
      "properties": {
        ...getSearchFields().reduce ((p,c)=> {
          p[c] = {
            "type": "dense_vector",
            "index": true,
            "similarity": "l2_norm"
          }
          return p
        }, {}),
        "file_name": {
          "type": "text"
        },
        "file_path": {
          "type": "text"
        },
        "created_at": {
          "type": "long",
          "index": false
        },
        "load_version": {
          "type": "text"
        }
      }

    }

  }]
}
